// @owners { team: patients }
import { Icon, ListDescription, ListItem, Tag } from '@alto/design-system';
import React from 'react';

type Props = {
  readonly onPress?: () => void;
  readonly loading?: boolean;
};

export const PlaidBankAccountListItem = ({ onPress, loading }: Props) => (
  <ListItem
    LeftContent={<Icon name="bank" />}
    RightContent={<Icon name="chevronright-small" />}
    title="Bank Account"
    tags={[
      <Tag
        label="Save 1%"
        key="save"
      />,
    ]}
    descriptions={<ListDescription>Save 1% on all orders without insurance</ListDescription>}
    loading={loading}
    onPress={onPress}
  />
);
